// This is a cheap implementation of a pub-sub bus based on https://github.com/developit/mitt project
// Used for now to replace `.$on` / `.$off` / `.$once` APIs removed in Vue3

// It's used for one single particular reason (tabChangeActive broadcast) and might be not needed at all.
// TODO: consider finding other options which don't utilize an external dependency (even though it's a tiny one)

// NOTE: it's useless during SSR phase

import mitt from 'mitt';

const instance = mitt();

export default instance;
